import { createFileRoute } from '@tanstack/react-router';
import { LegacyReportHandoff } from '@/pages/workspaces/analysis/report/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/reports` URL, which the embedded app serves and its
 * own nav links to. Flag off it renders that host; flag on it forwards to the
 * migrated URL.
 *
 * The resolver belongs here and not on the migrated twin: this URL keeps the
 * `journeys` segment, so a `/workspaces/last` sentinel has to be resolved
 * before the embedded app mounts on it.
 */
function JourneysReportsIndexRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <LegacyReportHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/reports/')({
  component: JourneysReportsIndexRoute,
});
